import { useState, useEffect } from "react";
import PopupModal from "../../components/controls/PopupModal";
import { useSelector } from "react-redux";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import Searchbar from "./Searchbar";

const MultipleStoreSelect = ({
    setPopup,
    initialSelectedStores = [],
    onStoreSelectionChange
}) => {
    console.log("initializedstores",initialSelectedStores);
    const [selectedStores, setSelectedStores] = useState([]);
    const storesList = useSelector((state) => state.store.storesList);
    const singleStore = useSelector((state) => state.store.store);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredStores, setFilteredStores] = useState([]);

    // Initialize selected stores
    useEffect(() => {
        if (initialSelectedStores && initialSelectedStores.length > 0) {
            // Case 1: Array of store objects
            if (typeof initialSelectedStores[0] === 'object' && initialSelectedStores[0].key) {
                setSelectedStores(initialSelectedStores);
            }
            // Case 2: Array of strings (store keys)
            else if (typeof initialSelectedStores[0] === 'string') {
                const availableStores = Array.isArray(storesList) ? storesList : singleStore ? [singleStore] : [];
                const matchedStores = initialSelectedStores
                    .map(key => availableStores.find(store => store.key === key))
                    .filter(Boolean);
                setSelectedStores(matchedStores);
            }
            // Case 3: Array of {label, value} objects
            else if (initialSelectedStores[0].value) {
                const availableStores = Array.isArray(storesList) ? storesList : singleStore ? [singleStore] : [];
                const matchedStores = initialSelectedStores
                    .map(({ value }) => availableStores.find(store => store.key === value))
                    .filter(Boolean);
                setSelectedStores(matchedStores);
            }
        } else {
            setSelectedStores([]);
        }
    }, [initialSelectedStores]);

    // Normalize stores to always be an array
    const stores =useSelector((state) => state.store.storesList);

            console.log("stores",stores);
            console.log("storeList",storesList);
            console.log("singleStore",singleStore);

    // Update filtered stores when search query or stores change
    useEffect(() => {
        if (searchQuery.trim() === "") {
            setFilteredStores(stores);
        } else {
            setFilteredStores(
                stores.filter((store) =>
                    store?.StoreName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    store?.StoreCode?.toLowerCase().includes(searchQuery.toLowerCase())
                )
            );
        }
    }, [searchQuery]);

    const handleSelectionChange = (store) => {
        const isSelected = selectedStores.some(s => s.key === store.key);
        const newSelectedStores = isSelected
            ? selectedStores.filter(s => s.key !== store.key)
            : [...selectedStores, store];

        setSelectedStores(newSelectedStores);
    };

    const handleSave = () => {
        if (onStoreSelectionChange) {
            // Pass the selected stores in the format the parent expects
            onStoreSelectionChange(selectedStores);
        }
        setPopup(false);
    };

    return (
        <PopupModal
            setPopUp={setPopup}
            size="small"
            saveClick={handleSave}
            handleClose={() => setPopup(false)}
            buttons={true}
            secondbtnname={"Ok"}
            title={"Select Store"}
        >
            <div className="grid gap-5">
                <Searchbar
                    value={searchQuery}
                    onChange={(e) => { setSearchQuery(e) }}
                    placeholder="Search for store..."
                    hideRefresh={true}
                    hideFilter={true}
                />
                <FormGroup>
                    {filteredStores.map((store) => (
                        <FormControlLabel
                            key={store.key}
                            control={
                                <Checkbox
                                    checked={selectedStores.some(s => s.key === store.key)}
                                    onChange={() => handleSelectionChange(store)}
                                />
                            }
                            label={`${store?.StoreCode || ''} ${store?.StoreName}`}
                        />
                    ))}
                </FormGroup>
            </div>
        </PopupModal>
    );
};

export default MultipleStoreSelect;